import { IStringAnyMap } from "../app.types";


export const PageConfig : IStringAnyMap = {
    start: [],
    notFound: ['404'],
}